//
// Lenis
// - We use Lenis for Smooth Scrolling
// - Find the docs here: https://github.com/darkroomengineering/lenis
//
import Lenis from '@studio-freight/lenis'
import GSAP from 'gsap'

export default class SmoothScroll {
	constructor() {

		this.lenis = new Lenis({
			duration: 0.1,
			ease: 'none',
		})

		this.rafCallback = this.rafCallback.bind(this)

		this.init()


		// Restoring Anchor Links Functionality
		this.anchorLinks 	= window.document.body.querySelectorAll('a[href^="#"]')
		this.scrollToHash	= this.scrollToHash.bind(this)
		this.anchorLinks && this.anchorLinks.forEach((link) => {

			link.addEventListener('click', e => {
				let hash = link.href.substr(link.href.indexOf('#')).substring(1)
				this.scrollToHash(hash, e);
			});

		})

	}

	init() {
		GSAP.ticker.add(this.rafCallback)
		GSAP.ticker.lagSmoothing(0)
	}

	rafCallback(time) {
		this.lenis.raf(time * 1000)
	}

	scrollToPosition(pos, instant) {
		this.lenis.scrollTo(pos, { immediate: instant })
	}

	scrollToHash(hash, e){

		const target = hash ? document.getElementById(hash) : document.body;
		
		if(target && this.lenis) {
			if(e) e.preventDefault();
			let options = {
				'duration': 1,
				'lock': true,
			}
			this.lenis.scrollTo(target, options);

		}
	
	}

	unmount() {
		GSAP.ticker.remove(this.rafCallback)
		this.lenis.destroy()
	}
}
